import client from '@/services/client'
import type {
  IIntegration,
  IIntegrationConfiguration,
} from '@/types/IntegrationTypes'

import type { AxiosResponse } from 'axios'

const getIntegrationParameters = async (
  flowUuid: string,
  fresh?: boolean
): Promise<AxiosResponse<IIntegration[]>> => {
  return await client.get<IIntegration[]>(
    `flows/${flowUuid}/integration-params`,
    { params: { fresh } }
  )
}

const findIntegrationParams = async (
  flowUuid: string,
  integrationCode: string
): Promise<AxiosResponse<IIntegration>> => {
  return await client.get<IIntegration>(
    `flows/${flowUuid}/integration-params/${integrationCode}`
  )
}

const getConfigurationConfig = async (): Promise<
  AxiosResponse<IIntegrationConfiguration>
> => {
  return await client.get<IIntegrationConfiguration>(`flows/config`)
}

export const IntegrationRepository = {
  getConfigurationConfig,
  getIntegrationParameters,
  findIntegrationParams,
}
